import React, { useEffect, useRef, useState } from "react";
import "../../styles/PastEventImages.scss";

interface PastEventItem {
  id: number;
  image: string;
}

const PastEventImages: React.FC = () => {
  const sliderRef = useRef<HTMLDivElement | null>(null);
  const directionRef = useRef(1);
  const [data, setData] = useState<PastEventItem[]>([]);

  useEffect(() => {
    fetch("/resources/pastevent.json")
      .then((res) => res.json())
      .then(setData)
      .catch(console.error);
  }, []);

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    let animationFrameId: number;
    let lastTime = performance.now();
    const directionChangeInterval = 13000;
    let nextDirectionChange = lastTime + directionChangeInterval;

    const slide = (time: number) => {
      const deltaTime = time - lastTime;
      lastTime = time;

      slider.scrollLeft += 0.05 * deltaTime * directionRef.current;

      if (time >= nextDirectionChange) {
        directionRef.current *= -1;
        nextDirectionChange = time + directionChangeInterval;
      }

      animationFrameId = requestAnimationFrame(slide);
    };

    animationFrameId = requestAnimationFrame(slide);
    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  return (
    <>
      <div className="pe-slider" ref={sliderRef}>
        {data.map((item) => (
          <img
            key={item.id}
            src={item.image}
            alt={`Past Event ${item.id}`}
            className="pe-slide-image"
          />
        ))}
      </div>
      <p className="pe-slide-credit">
        Photos courtesy of Thailand Convention and Exhibition Bureau | 2025
      </p>
    </>
  );
};

export default PastEventImages;
